export const BaseAPIUrl = '{BaseAPIUrl}';
// eslint-disable-next-line
export const Get_PostPurchase_API_Version = 'v1';
